module.exports = __webpack_public_path__ + "static/media/water-pump-mr-card-back.22983134.jpeg";